import { queries } from "./user.queries";
import { selectors } from "./user.selectors";
import { actions } from "./user.actions";

export const userRedux = {
  actions: actions,
  selectors: selectors,
  queries: queries,
};
